/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Import_Hls_PlaceholderInputs */

const en_media_import_hls_placeholder = /** @type {(inputs: Media_Import_Hls_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manifest URL`)
};

const fr_media_import_hls_placeholder = /** @type {(inputs: Media_Import_Hls_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL du manifeste`)
};

const de_media_import_hls_placeholder = /** @type {(inputs: Media_Import_Hls_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manifest-URL`)
};

const it_media_import_hls_placeholder = /** @type {(inputs: Media_Import_Hls_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL manifesto`)
};

const ru_media_import_hls_placeholder = /** @type {(inputs: Media_Import_Hls_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL манифеста`)
};

const es_media_import_hls_placeholder = /** @type {(inputs: Media_Import_Hls_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL del manifiesto`)
};

const zh_cn2_media_import_hls_placeholder = /** @type {(inputs: Media_Import_Hls_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`清单网址`)
};

const ja_media_import_hls_placeholder = /** @type {(inputs: Media_Import_Hls_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マニフェストURL`)
};

const hi_media_import_hls_placeholder = /** @type {(inputs: Media_Import_Hls_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मैनिफेस्ट यूआरएल`)
};

const pt_pt2_media_import_hls_placeholder = /** @type {(inputs: Media_Import_Hls_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL do manifesto`)
};

/**
* | output |
* | --- |
* | "Manifest URL" |
*
* @param {Media_Import_Hls_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_import_hls_placeholder = /** @type {((inputs?: Media_Import_Hls_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Import_Hls_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_media_import_hls_placeholder(inputs)
	if (locale === "de") return de_media_import_hls_placeholder(inputs)
	if (locale === "it") return it_media_import_hls_placeholder(inputs)
	if (locale === "ru") return ru_media_import_hls_placeholder(inputs)
	if (locale === "es") return es_media_import_hls_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_media_import_hls_placeholder(inputs)
	if (locale === "ja") return ja_media_import_hls_placeholder(inputs)
	if (locale === "hi") return hi_media_import_hls_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_media_import_hls_placeholder(inputs)
	return en_media_import_hls_placeholder(inputs)
});